import { render, staticRenderFns } from "./SCMEvaluation.vue?vue&type=template&id=67c92fe6"
import script from "./SCMEvaluation.vue?vue&type=script&lang=js"
export * from "./SCMEvaluation.vue?vue&type=script&lang=js"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports